import React, { useEffect, useState } from "react"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory from "react-bootstrap-table2-paginator"
import { connect } from "react-redux"
import { Button, ButtonGroup, Card, CardBody, CardFooter, Col, Container, Input, Row, Spinner } from "reactstrap"
import * as actions from "../../store/users/actions"
//Import Breadcrumb
import { useFormik } from "formik"
import { Link, useHistory } from "react-router-dom"
import Loader from "../../common/Loader"
import CustomModal from "../../components/Common/CustomModal"
import { sizePerPageList } from "../Utility/sizePerPageList"
import Validations from "./Form/Validations"
import UserColumns from './UserColumns'
import AutoLogout from "../Authentication/AutoLogout";

const Users = ({errors, users, getUsers, getTypes, totalCount, remove, changePassword, updatingPassword, updatedPassword, toggle, saved, toggled, UserId, isLoading, roles }) => {
    const [RegeneratePasswordModal, setRegeneratePasswordModal] = useState(false)
    const [ToggleUserModal, setToggleUserModal] = useState(false)
    const [FilterActive, setFilterActive] = useState(5)
    const [Filters, setFilters] = useState({typeId:null});
    const history = useHistory();
    const [SelectedUser, setSelectedUser] = useState();
    const [SelectedRol, setSelectedRol] = useState();
    const [UserState, setUserState] = useState(false)
    const [CurrentPage, setCurrentPage] = useState(1);
    const [UserType, setUserType] = useState();
    const [pageSize, setPageSize] = useState(10);
    const [PageOptions, setPageOptions] = useState({
        hideSizePerPage: true,
        sizePerPage: pageSize,
        showTotal: true,
        totalSize: users?.rowCount ?? 0, // replace later with size(users),
        page:  users?.currentPage ?? 1,
        active: true,
        sizePerPageList: sizePerPageList,
        paginationTotalRenderer: (from, to, size) => (
            <span className="react-bootstrap-table-pagination-total">
                Mostrando {from} a {to} de {size} Resultados
            </span>
        )
    })

    const [Shearch, setShearch] = useState(null);

    const defaultSorted = [{
        dataField: 'id',
        order: 'desc'
    }];

    // const { SearchBar } = Search

    const handleSelectedUser = id => {
        setSelectedUser(id)
        setRegeneratePasswordModal(true);
    }

    const handleToggle = (id, status) => {
        setSelectedUser(id);
        setUserState(status);
        setToggleUserModal(true);

    }

    const handleNewUser = () => history.push("/user/add");
    const handleFilterUsers = ( value ) =>{
      const {RoleId} = SelectedRol ?? {};
      setShearch(value);
        if(value.length%3 ==0){
            getUsers({Name:value, RoleId})
            setCurrentPage(1);
            

        }else if(value.length==0){
            getUsers({Name:value,RoleId})
            setCurrentPage(1);
        }
    }

    const changePasswordFormik = useFormik({
        initialValues: { password: " ", userId:""},
        onSubmit: values => {
            changePassword({ ...values, userId: SelectedUser });
        }
    })

    useEffect(() => {
        if (updatedPassword) {
            setTimeout(() => {
                setRegeneratePasswordModal(false)
            }, 1000);
        }
    }, [updatedPassword])


    useEffect(() => {
        if (toggled) {
            getUsers({Name:Shearch});
            setCurrentPage(1);
            setTimeout(() => {
                setToggleUserModal(false)
            }, 1000);
        }
    }, [toggled])

    useEffect(() => {
        if (saved) {
            getUsers({Name:Shearch});
            setCurrentPage(1);
        }
    }, [saved])

    useEffect(() => {
        getTypes();
        getUsers({Name:Shearch, pageNumber: 1, PageSize: pageSize })
        setCurrentPage(1);
    }, [])



    const handlePageChange = (style, values) => {
        setCurrentPage(values?.page);
        const {RoleId} = SelectedRol ?? {};
        getUsers({ pageNumber: values?.page, PageSize: pageSize, RoleId,Name:Shearch })
    }

    useEffect(() => {
      
            setPageOptions({
                hideSizePerPage: true,
                sizePerPage: pageSize,
                showTotal: true,
                totalSize: users?.rowCount ?? 0, // replace later with size(users),
                page:  users?.currentPage ?? 1,
                active: true,
                sizePerPageList: sizePerPageList,
               
                paginationTotalRenderer: (from, to, size) => (
                    <span className="react-bootstrap-table-pagination-total">
                        Mostrando {from} a {to} de {size} Resultados
                    </span>
                )
            })
    

    }, [users])

    const handleGetUsers = (filter) =>{
      
        setSelectedRol(filter)
        setUserType(filter.typeId)
        getUsers({...filter, pageNumber: 1, PageSize: pageSize,Name:Shearch});
        setCurrentPage(1);
    }
    const handleRegeneratePasswordModal = () => setRegeneratePasswordModal(!RegeneratePasswordModal)
    const handleToggleModal = () => setToggleUserModal(!ToggleUserModal);
    return (
        <React.Fragment>
            <AutoLogout /> {/* Activa el cierre de sesión por inactividad */}
            <div className="page-content">
                <Container fluid>

                    <Row>
                        <Col xs="12">
                            <div className="page-title-box d-flex align-items-center justify-content-between">
                                <h4 className="mb-0">{`Usuarios`}</h4>

                                <div className="page-title-right">
                                    <Link className='btn btn-light' to={"/dashboard"}> <i className="mdi mdi-keyboard-backspace me-2"></i> Volver</Link> {' '}
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs="12">
                            <Card>
                                <CardBody>

                                    <React.Fragment>
                                        <Row>
                                            <Col sm="4">
                                            <div className="text-sm">
                                                <Input autoFocus placeholder="Buscar usuarios" onChange={({target:{value}})=>handleFilterUsers(value)} color="light" className="btn-rounded "></Input>
                                                </div>
                                            </Col>
                                            <Col sm="8">
                                              
                                                <div className="text-sm-end">
                                                <ButtonGroup size="md" className="mb-2 me-2">
                                                        <Loader isLoading={isLoading}></Loader>
                                                       {
                                                        roles && !isLoading && roles.map((i,indx)=>(
                                                        <Button active={FilterActive == indx-1} onClick={() => {handleGetUsers({ pageNumber: 1, PageSize: pageSize, RoleId: i.id}); setFilterActive(indx-1) }} color="light" className="btn-rounded " >
                                                         {i.name}
                                                    </Button>))
                                                       }
                                                       <Button active={FilterActive == 5} onClick={() => {handleGetUsers({ pageNumber: 1, PageSize: pageSize, typeId: null}); setFilterActive(5) }} color="light" className="btn-rounded " >
                                                        <i className="mdi mdi-account-group-outline font-size-14"></i>  Todos
                                                    </Button>
                                                    </ButtonGroup>
                                                    <Button
                                                        type="button"
                                                        color="success"
                                                        className="btn-rounded mb-2 me-2"
                                                        onClick={handleNewUser}
                                                    >
                                                        <i className="mdi mdi-plus me-1" />{" "}
                                                        Nuevo usuario
                                                    </Button>

                                                </div>
                                            </Col>
                                        </Row>

                                        <div className="table table-responsive">
                                            <BootstrapTable
                                                remote
                                                keyField={"id"}
                                                responsive
                                                bordered={false}
                                                striped={false}
                                                defaultSorted={defaultSorted}
                                                classes={
                                                    "table align-middle table-nowrap table-sm"
                                                }
                                                onTableChange={handlePageChange}
                                                pagination={paginationFactory({ ...PageOptions, pageNumber: CurrentPage })}

                                                columns={UserColumns(remove, handleSelectedUser, handleToggle, history, UserId)}
                                                data={users?.data ?? []}
                                                search={false}
                                                headerWrapperClasses={"thead-light"}
                                            />

                                        </div>

                                    </React.Fragment>

                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
            <CustomModal
                title={"Regenerar Contraseña"}
                size='LG'
                handleToggle={handleRegeneratePasswordModal}
                centered
                isOpen={RegeneratePasswordModal}
                children={<>
                    <form onSubmit={changePasswordFormik.handleSubmit}>
                     <input hidden name="UserId"  value={SelectedUser}/>
                        <Card>
                          {errors && <Validations errors={errors} /> }
                            <CardBody>
                                <Row className="mb-3">
                                    <Col md={12}>
                                        <Input
                                            placeholder="Nueva contraseña"
                                            id='password'
                                            name="password"
                                            onChange={changePasswordFormik.handleChange}
                                            type="password" />
                                    </Col>
                                </Row>
                            </CardBody>
                            <CardFooter>
                                <Row>
                                    <Button disabled={updatingPassword} className="btn btn-success btn-lg btn-block  btn btn-primary " color="success" type="submit" >
                                        {updatingPassword ? <Spinner size='sm'></Spinner> : 'Guardar'}
                                    </Button>
                                </Row>
                            </CardFooter>
                        </Card>
                    </form>

                </>}
            />

            <CustomModal
                title={`${UserState ? 'Desactivar' : 'Activar'} usuario`}
                size='sm'
                handleToggle={handleToggleModal}
                centered
                isOpen={ToggleUserModal}
                children={<>
                    <Card>
                        <CardFooter>
                            <Row>
                                <Button disabled={updatingPassword} onClick={() => toggle({ userId: SelectedUser })} className="btn btn-success btn-lg btn-block  btn btn-primary " color={`${UserState ? 'danger' : 'success'}`}>
                                    {updatingPassword ? <Spinner size='sm'></Spinner> : UserState ? 'Desactivar' : 'Activar'}
                                </Button>
                            </Row>
                        </CardFooter>
                    </Card>
                </>}
            />
        </React.Fragment>
    );
}

const mapStateToProps = state => ({
    totalCount: state.Users?.totalCount,
    users: state?.Users?.users??undefined,
    isLoading: state?.Users?.isFetching??false,
    UserId: state.Login?.user?.id??null,
    updatingPassword: state.Users?.updatingPassword,
    updatedPassword: state.Users?.updatedPassword,
    saved: state.Users.saved,
    updateEntity: state.Users.updatingEntity,
    toggled: state.Users.toggled,
    roles: state.Users?.types,
    errors: state.Users?.error??undefined
});



export default connect(mapStateToProps, actions)(Users);